<template>
  <footer id="footer">
  	<div class="fff_003">
      <div class="commonInnerEx">
        <div class="companyInfo">
          <a href="//flightsinc.jp" target="_blank"><img src="../assets/logo_inc.png" alt="FLIGHTS inc."></a>
          <div class="in">
            <span>株式会社FLIGHTS　TEL: 03-5860-1023</span>
            <span>〒105-0004　東京都港区新橋5丁目8-4 柴田ビル2F</span>
          </div>
        </div>
        <div class="ftrNav">
          <nav>
            <small class="copyright">&#169; {{ new Date().getFullYear() }} FLIGHTS inc.</small>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style scoped>
  @import '../assets/css/footer.css'
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue